import { render, staticRenderFns } from "./PurchaseDuoDeliveriesPerWeek.vue?vue&type=template&id=37d5879f&"
import script from "./PurchaseDuoDeliveriesPerWeek.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoDeliveriesPerWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports